import React, { useEffect, useState } from 'react';
import api from '../../../utils/api';

const Services = ({ userId }) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [empty, setEmpty] = useState(false);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await api.get(`/api/users/${userId}/subscriptions`);
        if (res.data.length === 0) {
          setEmpty(true);
        } else {
          setSubscriptions(res.data);
        }
      } catch (err) {
        console.error('Error al obtener los servicios:', err);
        setEmpty(true);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, [userId]);

  if (loading) return <p className="p-8 text-center">Cargando...</p>;

  if (empty) {
    return (
      <div className="text-center py-20 text-gray-500">
        <svg className="mx-auto h-10 w-10 text-gray-300" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 className="mt-2 text-sm font-semibold text-gray-900">Sin servicios asociados</h3>
        <p className="mt-1 text-sm text-gray-500">Este usuario no tiene servicios activos actualmente.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-6">Servicios del Cliente</h2>
      <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {subscriptions.map((sub) => (
          <li key={sub.id} className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900">{sub.service_name}</h3>
              <p className="text-sm text-gray-500 mt-1">{sub.plan_name} – ${sub.price} / {sub.billing_cycle}</p>
              <p className="text-sm text-gray-500 mt-1">Inicio: {new Date(sub.start_date).toLocaleDateString()}</p>
              <span
  className={`inline-block mt-2 px-3 py-1 rounded-full text-xs font-medium ${
    sub.status === 'active'
      ? 'bg-green-100 text-green-800'
      : sub.status === 'inactive'
      ? 'bg-gray-100 text-gray-800'
      : 'bg-yellow-100 text-yellow-800'
  }`}
>
  {sub.status === 'active'
    ? 'Activo'
    : sub.status === 'inactive'
    ? 'Inactivo'
    : 'Pendiente'}
</span>

<p className="text-xs text-gray-500 mt-1">
  Próxima factura en {sub.days_until_next_billing} día{sub.days_until_next_billing === 1 ? '' : 's'}
</p>

            </div>
            <div className="p-4 bg-gray-50 text-sm">
              <a href="#" className="font-medium text-indigo-600 hover:text-indigo-900">Gestionar suscripción →</a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Services;
